import React from 'react';
import {
  default as MuiInputAdornment,
  InputAdornmentProps as MuiInputAdornmentProps,
  InputAdornmentTypeMap as MuiInputAdornmentTypeMap,
} from '@mui/material/InputAdornment';
import {
  DistributiveOmit,
  OverridableComponent,
  OverrideProps,
} from '@mui/types';

/**
 * Props that we do not want to include with InputAdornment.
 *
 * Using `keyof Pick` provides type safety that ensures we are
 * only blocking props that are part of the interface.
 **/
type InputAdornmentBlockedProps = keyof Pick<MuiInputAdornmentProps, 'variant'>;

export interface InputAdornmentTypeMap<
  // eslint-disable-next-line @typescript-eslint/ban-types
  AdditionalProps = {},
  RootComponent extends React.ElementType = MuiInputAdornmentTypeMap['defaultComponent']
> {
  props: AdditionalProps &
    DistributiveOmit<MuiInputAdornmentProps, InputAdornmentBlockedProps>;
  defaultComponent: RootComponent;
}

export type InputAdornmentProps<
  RootComponent extends React.ElementType = InputAdornmentTypeMap['defaultComponent'],
  // eslint-disable-next-line @typescript-eslint/ban-types
  AdditionalProps = {}
> = OverrideProps<
  InputAdornmentTypeMap<AdditionalProps, RootComponent>,
  RootComponent
> & {
  component?: React.ElementType;
};

export const InputAdornment: OverridableComponent<InputAdornmentTypeMap> =
  MuiInputAdornment;
